module.exports = __webpack_public_path__ + "static/img/pdc-sample-cheque.dc6ca552.png";